import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { BASE_API_URL } from "../../core/environment.tokens";
import { StringHelper } from "../../utilities/contracts/string-helper";

interface ISocialMedia {
  Linkedin: string;
  Facebook: string;
  Twitter: string;
}

@Injectable({
  providedIn: "root",
})
export class SocialMediaService {
  private linkedin = new BehaviorSubject("");
  private pLinkedinUrl$ = this.linkedin.asObservable();
  private facebook = new BehaviorSubject("");
  private pFacebookUrl$ = this.facebook.asObservable();
  private twitter = new BehaviorSubject("");
  private pTwitterUrl$ = this.twitter.asObservable();
  private loading = false;

  constructor(
    @Inject(BASE_API_URL) private readonly baseApiUrl: string,
    private readonly http: HttpClient
  ) {}

  get linkedinUrl$(): Observable<string> {
    this.lazyLoadSocialMediaUrls();
    return this.pLinkedinUrl$;
  }

  get facebookUrl$(): Observable<string> {
    this.lazyLoadSocialMediaUrls();
    return this.pFacebookUrl$;
  }

  get twitterUrl$(): Observable<string> {
    this.lazyLoadSocialMediaUrls();
    return this.pTwitterUrl$;
  }

  private lazyLoadSocialMediaUrls(): void {
    const hasLinkedin = StringHelper.isAvailable(this.linkedin.getValue());
    const hasFacebook = StringHelper.isAvailable(this.facebook.getValue());
    const hasTwitter = StringHelper.isAvailable(this.twitter.getValue());
    if (!this.loading && (!hasLinkedin || !hasFacebook || !hasTwitter)) {
      this.loadSocialMediaUrls();
    }
  }

  private loadSocialMediaUrls(): void {
    this.loading = true;
    const url = `${this.baseApiUrl}navigation/socialmedia`;
    this.http
      .get(url)
      .pipe(finalize(() => this.loading = false))
      .subscribe((response: ISocialMedia) => {
        this.linkedin.next(response.Linkedin);
        this.facebook.next(response.Facebook);
        this.twitter.next(response.Twitter);
      });
  }
}
